import React from "react";

interface WarningAlertIconProps extends React.SVGProps<SVGSVGElement> {
	className?: string;
	width?: number | string;
	height?: number | string;
	primaryColor?: string;
}

const WarningAlertIcon: React.FC<WarningAlertIconProps> = ({
	className,
	width = 41,
	height = 41,
	style,
	primaryColor = "#5B5B5B",
	...props
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 41 41"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		style={style}
		{...props}
	>
		<path
			d="M20.5 15.4982V18.8315M20.5 25.4982V25.5149M8.8332 32.1649H32.1665C32.7104 32.1611 33.245 32.0243 33.7239 31.7664C34.2027 31.5085 34.6111 31.1373 34.9136 30.6853C35.216 30.2333 35.4032 29.7141 35.4589 29.1731C35.5147 28.6321 35.4372 28.0857 35.2332 27.5816L23.3999 7.1649C23.1116 6.6439 22.689 6.20962 22.1761 5.90721C21.6632 5.60481 21.0786 5.44531 20.4832 5.44531C19.8878 5.44531 19.3032 5.60481 18.7903 5.90721C18.2774 6.20962 17.8548 6.6439 17.5665 7.1649L5.7332 27.5816C5.5331 28.0742 5.45376 28.6075 5.50179 29.1371C5.54981 29.6666 5.72382 30.177 6.00929 30.6256C6.29475 31.0742 6.68339 31.448 7.14275 31.7157C7.60211 31.9835 8.11886 32.1375 8.64987 32.1649"
			stroke={primaryColor}
			strokeWidth={2}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M20.5 15.4982V18.8315M20.5 25.4982V25.5149M8.8332 32.1649H32.1665C32.7104 32.1611 33.245 32.0243 33.7239 31.7664C34.2027 31.5085 34.6111 31.1373 34.9136 30.6853C35.216 30.2333 35.4032 29.7141 35.4589 29.1731C35.5147 28.6321 35.4372 28.0857 35.2332 27.5816L23.3999 7.1649C23.1116 6.6439 22.689 6.20962 22.1761 5.90721C21.6632 5.60481 21.0786 5.44531 20.4832 5.44531C19.8878 5.44531 19.3032 5.60481 18.7903 5.90721C18.2774 6.20962 17.8548 6.6439 17.5665 7.1649L5.7332 27.5816C5.5331 28.0742 5.45376 28.6075 5.50179 29.1371C5.54981 29.6666 5.72382 30.177 6.00929 30.6256C6.29475 31.0742 6.68339 31.448 7.14275 31.7157C7.60211 31.9835 8.11886 32.1375 8.64987 32.1649"
			stroke={"black"}
			strokeOpacity={0.2}
			strokeWidth={2}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default WarningAlertIcon;
